import React from 'react';
import { XIcon } from '@fronton/icons-react';
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader, RegularButton } from 'fronton-react';
import { DocumentsList } from '../documents-list/documents-list';
import { ContentProps } from '../../types';
import { ErrorState } from '../error-state/error-state';
import { LoadingState } from '../loading-state/loading-state';
import { useTranslation } from 'react-i18next';
import { closeButton, drawerHeaderStyle } from './styles';

export const PRODUCT_QUALITY_DRAWER_DATA_QA = 'product-quality-drawer';

export const ProductQualityDrawer = ({
  show,
  manuals,
  certificates,
  additionalText,
  isError,
  isLoading,
  onClose,
  onRetry,
}: ContentProps) => {
  const { t } = useTranslation();
  const hasRenderContent = !isError && !isLoading;

  const closeText = t('product-info.manuals.close');

  return (
    <Drawer data-qa={PRODUCT_QUALITY_DRAWER_DATA_QA} show={show} onClose={onClose}>
      <DrawerHeader
        className={drawerHeaderStyle}
        hideBackArrowButton={true}
        onClickBack={() => {}}
        title="Документы на товар"
      >
        <RegularButton
          className={closeButton}
          variant="pseudo"
          iconOnly={true}
          label={closeText}
          onClick={onClose}
          rounded
          size="s"
        >
          <XIcon type="outline" size="m" color="text-primary" />
        </RegularButton>
      </DrawerHeader>

      <DrawerContent>
        {isError && <ErrorState />}
        {isLoading && <LoadingState />}
        {hasRenderContent && (
          <DocumentsList manuals={manuals} certificates={certificates} additionalText={additionalText} />
        )}
      </DrawerContent>

      <DrawerFooter>
        {isError ? (
          <RegularButton onClick={onRetry} size="l" variant="primary">
            {t('product-info.manuals.error-state.retry-button')}
          </RegularButton>
        ) : (
          <RegularButton onClick={onClose} size="l" variant="secondary">
            {closeText}
          </RegularButton>
        )}
      </DrawerFooter>
    </Drawer>
  );
};
